import axios from 'axios';
import SidebarWrap from '../SidebarWrap';
import Loader from 'react-loader-spinner';
import MDEditor from '@uiw/react-md-editor';
import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import { formatDate } from '../../utils/moment.util';

import './style.css';

const baseUrl = process.env.REACT_APP_BASE_URL;

const EventSingle = () => {
  const [event, setEvent] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);

  const { slugId } = useParams();

  useEffect(() => {
    axios
      .get(`${baseUrl}/event/slug/${slugId}`)
      .then((res) => {
        setEvent(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoadingError(true);
        setLoading(false);
      });
  }, [slugId]);

  return (
    <div className="wpo-event-details-area section-padding">
      <div className="container">
        {loading ? (
          <div className="loader-container">
            <Loader type="Oval" color="#d90404" height={80} width={80} />
          </div>
        ) : loadingError ? (
          <div className="text-center">
            <p>Could not fetch the event. Refresh or check back later.</p>
          </div>
        ) : (
          <div className="row">
            <div className="col col-lg-8">
              <div className="wpo-event-item">
                <div className="wpo-event-img">
                  <img src={event.image} alt="" />
                  <div className="thumb-text">
                    <span>{formatDate(event.date, 'DD')}</span>
                    <span>{formatDate(event.date, 'MMM')}</span>
                    <span>{formatDate(event.date, 'YYYY')}</span>
                  </div>
                </div>
                <div className="wpo-event-details-text">
                  <h2>{event.title}</h2>
                  <MDEditor.Markdown source={event.body} />
                </div>
              </div>
            </div>
            <SidebarWrap />
          </div>
        )}
      </div>
    </div>
  );
};

export default EventSingle;
